
import { storage } from '@vmos2/core';
import { utcToZonedTime } from 'date-fns-tz';

export const setOrderJourneyStartTime = (timezone: string) => {
  storage.setItem('orderJourneyStartTime', utcToZonedTime(new Date(), timezone).getTime());
};
